export default __webpack_public_path__ + "static/media/icon-twitter.01a8907d.svg";